import { render, staticRenderFns } from "./setchartlist.vue?vue&type=template&id=28edc4c8&scoped=true"
import script from "./setchartlist.vue?vue&type=script&lang=js"
export * from "./setchartlist.vue?vue&type=script&lang=js"
import style0 from "./setchartlist.vue?vue&type=style&index=0&id=28edc4c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edc4c8",
  null
  
)

export default component.exports